import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isSubmitting } from 'redux-form';
import classNames from 'classnames';

import { submitForm } from 'State/forms/actions';

import { ToolboxRightButtons } from 'Components/toolbox/ToolboxRightButtons';
import { ToolboxBackButton } from 'Components/toolbox/ToolboxBackButton';

class ToolboxContainer extends Component {
  render() {
    if (!this.props.shown) {
      return null;
    }

    const {
      backButtonProps,
      className,
      dirtyTracking,
      isReadOnly,
      formName,
      rightButtons,
      saveLoading,
      saveButtonProps,
      submitForm,
    } = this.props;

    return (
      <div className={classNames('toolbox', className)}>
        <ToolboxBackButton {...backButtonProps} {...dirtyTracking} />
        <ToolboxRightButtons
          buttons={rightButtons}
          formName={formName}
          saveButtonProps={{
            ...saveButtonProps,
            loading: saveButtonProps.loading || saveLoading,
            disabled: saveButtonProps.disabled || isReadOnly || saveLoading,
          }}
          submitForm={submitForm}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { formName } = ownProps;
  const saveLoading = isSubmitting(formName)(state);

  return { saveLoading };
};

const Toolbox = connect(mapStateToProps, { submitForm })(ToolboxContainer);

Toolbox.defaultProps = {
  saveButtonProps: {},
};

export { Toolbox };



// WEBPACK FOOTER //
// ./src/components/toolbox/Toolbox.js